import React from 'react'

import { Text } from '../text'
import { splitTextWithLinks } from './linkify'
import type { TextWithLinksProps } from './types'
import { linkSegmentClasses } from './variants'

export const TextWithLinks = React.memo(({ text, ...textProps }: TextWithLinksProps) => (
    <Text {...textProps}>
        {splitTextWithLinks(text).map((segment, i) =>
            segment.type === 'link' ? (
                <a
                    key={i}
                    href={segment.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={linkSegmentClasses}
                >
                    {segment.label}
                </a>
            ) : (
                segment.value
            ),
        )}
    </Text>
))

TextWithLinks.displayName = 'TextWithLinks'
